import { AfterViewInit, Component, HostListener, ViewChild } from '@angular/core';
import { IonContent, ModalController, NavParams } from '@ionic/angular';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';

export interface IConsumptionSummaryItem {
    Label: string;
    Value: string;
    Icon?: string; // ionicon (detalhes)
    Highlight?: boolean; // destaque (valores principais)
}

/**
 * Resumo do registo de consumo com pedido de confirmação (Payshop).
 * Substitui os alertas de texto: valores em destaque, detalhes da operação e aviso opcional.
 * Fecha com `EnumGenericRoleActionAlerts.Confirm` ou `Cancel`.
 */
@Component({
    selector: 'app-consumption-summary',
    templateUrl: './consumption-summary.component.html',
    styleUrls: ['./consumption-summary.component.scss'],
})
export class ConsumptionSummaryModalComponent implements AfterViewInit {

    /** Conteúdo (scroll): o operador só confirma depois de percorrer todos os dados. */
    @ViewChild(IonContent) private Content: IonContent;

    /** Falso enquanto existir conteúdo por ver (sem overflow é logo verdadeiro). */
    public HasScrolledToEnd: boolean = false;

    public Title: string = $localize`:@@merchant_crud_movements_summary.default-title:Confirmar registo de consumo`;

    /** Texto de introdução (acima dos valores). */
    public Message: string = $localize`:@@merchant_crud_movements_summary.message:Está prestes a confirmar o registo da fatura.`;

    /** Pergunta de confirmação (abaixo dos detalhes, antes dos botões). */
    public Question: string = $localize`:@@merchant_crud_movements_summary.question:Confirma que os valores estão corretos?`;

    public Summary: IConsumptionSummaryItem[] = [];

    /** Aviso (ex.: fatura acima do limite do apoio). */
    public Warning: string = null;

    constructor(
        private NavParams: NavParams,
        private ModalController: ModalController) {

        this.Title = this.NavParams.get('title') || this.Title;
        this.Message = this.NavParams.get('message') || this.Message;
        this.Question = this.NavParams.get('question') || this.Question;
        this.Summary = this.NavParams.get('summary') || [];
        this.Warning = this.NavParams.get('warning') || null;
    }

    ngAfterViewInit() {
        // o modal anima à entrada: reavalia depois de o conteúdo estar renderizado
        setTimeout(() => this.OnScroll(), 100);
        setTimeout(() => this.OnScroll(), 500);
    }

    @HostListener('window:resize')
    async OnScroll() {

        const el = await this.Content?.getScrollElement();

        if (!el) return;

        this.HasScrolledToEnd = (el.scrollHeight - el.clientHeight) <= 8
            || (el.scrollTop + el.clientHeight) >= (el.scrollHeight - 8);
    }

    get Highlights(): IConsumptionSummaryItem[] {
        return this.Summary.filter(it => it?.Highlight);
    }

    get Details(): IConsumptionSummaryItem[] {
        return this.Summary.filter(it => !it?.Highlight);
    }

    OnConfirm() {
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Confirm);
    }

    OnCancel() {
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Cancel);
    }
}
